export default __webpack_public_path__ + "static/background-circles4-4c232cc800ce60bb82ee03be8916af92.png";